export const api_url = process.env.REACT_APP_API_URL;

export const modals = {
 addSubscriptionPackage: 'ADD_SUBSCRIPTION_PACKAGE',
 editSubscriptionPackage: 'EDIT_SUBSCRIPTION_PACKAGE'
}

